import { React, useState, useEffect } from "react";
import axios from "axios";
import servicesApi from "../../../seller-apis/servicesApi";
import {
  pendforapprovProducts,
  pendingProducts,
  rejectedProducts,
  searchManufacturers,
} from "../../../seller-apis/apidataField";
import { useAlert } from "react-alert";
import api from "../../../seller-apis/api";
import "./form.css";
import { variables } from "../../../Variables.json";
import "../../../assets/css/form.css";
import { ProgressBar, Offcanvas, Container, Row, Card } from "react-bootstrap";
import Categories from "../ChooseProduct/Categories";
import convertFileToWebP from "../../../utilities/convertFileToWebP";
import { countries } from "../../../utilities/countries";
import WeightComponent from "../../common/WeightComponent";
import { useDispatch, useSelector } from "react-redux";
import { packagesFttoCm } from "../../../utilities/conversion";
import { resetPackages } from "../../../Actions/PackageWeight";
// Images related
var imagesName = [];
var s3Urls = [];
var imgUrls = [];
var backeyactive = false;

// Videos related

var videosName = [];
var vids3Urls = [];
var currentLink;
var catList = [];
var histStat = [];

// For new vendors register

let isNewVend;
let NewVendTotalprcount;
const Formdemo = (props) => {
  const { id } = props.match.params;
  const alert = useAlert();
  const [pName, setpName] = useState("");
  const [price, setPrice] = useState("");
  const [description, setdescription] = useState("");
  const [taxClass, settaxClass] = useState();
  const [shortdescription, setshortdescription] = useState("");
  const [hsnCode, sethsnCode] = useState("");
  const [keywords, setkeywords] = useState([]);
  const [currKeyword, setcurrKeyword] = useState("");
  const [status, setStatus] = useState("pending");
  const [brand, setbrand] = useState("");
  const [brandInput, setbrandInput] = useState("");
  const [brandid, setbrandid] = useState("");
  const [category, setcategory] = useState("");
  const [isselectedCat, setisselectedCat] = useState(false);
  const [error, setError] = useState(false);
  const [selectedcat, setselectedcat] = useState();
  const [brandList, setbrandList] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState('');
  // states input

  const [longDesLen, setlongDesLen] = useState(0);
  const [pNameLen, setpNameLen] = useState(60);

  // Images Related
  const [urlList, seturlList] = useState([]);
  const [image1, setimage1] = useState("");
  const [image2, setimage2] = useState("");
  const [image3, setimage3] = useState("");
  const [imagecov, setimagecov] = useState("");
  const [urlListshow, seturlListshow] = useState(false);
  const [imgprogress, setimgprogress] = useState();
  const [imgLabelDisable, setimgLabelDisable] = useState(false);

  // Videos related
  const [vidurlList, setvidurlList] = useState([]);
  const [vidurlListshow, setvidurlListshow] = useState(false);
  const [progress, setProgress] = useState();
  const [videoShow, setvideoShow] = useState("none");

  // Select category related
  const [mcList, setcList] = useState([]);

  const [scList, setscList] = useState([]);
  const [state, setState] = useState("category");
  const [breadCrumb, setbreadCrumb] = useState([]);
  const [show, setShow] = useState(false);
  const [vendorId, setvendorId] = useState(localStorage.getItem("vendorId"));
  const [utubevideo, setutubevideo] = useState(undefined);

  const [pkgCount, setPkgCount] = useState(0);
  const [sellerPkgs, setSellerPkgs] = useState([]);

  // sl-712
  const { packages, packageCount, uploadProgress } = useSelector(state => state.packageReducer);
  const dispatch = useDispatch()
  //SL-699 Seller Stock
  const [stockValue, setStockValue] = useState("");

  useEffect(()=>{
    if (props.match.params.type=='draft') {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: 'smooth',
    });
    dispatch(resetPackages())
  }
  },[])
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  useEffect(async () => {
    isNewVend = false;
    NewVendTotalprcount = 0;
    let data = {};
    servicesApi.categories
      .categoryTree(data)
      .then((res) => {
        catList = res.data.subCategories;
        setcList(res.data.subCategories);
      })
      .catch((err) => console.log(err));

    if (window.location.href.includes("newVendor")) {
      isNewVend = true;
      let filter = {
        pageNo: "1",
        size: 1,
      };
      // New request for approval Products
      api.product
        .vExPrdReqRetrieveAll(pendforapprovProducts(filter))
        .then((res) => {
          NewVendTotalprcount = NewVendTotalprcount + res.totalRecords;
        })
        .catch((err) => console.log(err));

      // // Pending products
      api.product
        .newProductsRetrieveall(pendingProducts(filter))
        .then((res) => {
          NewVendTotalprcount = NewVendTotalprcount + res.totalRecords;
        })
        .catch((err) => console.log(err));
    }
    if (props.match.params.id) {
    api.product
      .getProductById(id)
      .then(async (res) => {
        let categoriestemp=res.data?.categories;
        let cats=[];
        res.data?.categories.forEach(element => {
          cats.push(element._id);
        });
        setcategory(cats);
        
        setselectedcat(
          categoriestemp[categoriestemp.length - 1]?.categoryName
        );
        setpName(res.data.productName);
        setisselectedCat(true);
        setStatus("draft");
        if(res.data.pkgs.length>0){
        setPkgCount(res.data.pkgs.length);
        setSellerPkgs(res.data.pkgs);
        }
        if(res.data.price){
        setPrice(res.data.price.toString());
        }
        setshortdescription(res.data.shortDescription);
        setdescription(res.data.description);
        setlongDesLen(res.data?.description?.length);
        setkeywords(res.data?.metaInformation?.keywords);
        setbrandid(res.data.manufacturer);
        let brandData = await api.brand.getManufacturers({
          filter: { manufacturerId: parseInt(res.data.manufacturer) },
        });
        brandData = brandData.data;
        if (brandData.length > 0) {
          setbrandInput(brandData[0].name);
          setbrand(brandData[0].name);
        }
        sethsnCode(res.data.HSN);
        settaxClass(res.data.taxClass||0);
        //SL-699
        setStockValue(res.data?.stock || '');
        imgUrls.push(...res.data.images);
        if(res.data?.videos?.length>0 && res.data?.videos[0]!=null){
        if(res.data.videos[0].includes('http')){
          setutubevideo(res.data.videos[0]);
        }
        else{
        videosName.push(...res.data.videos);
        }
       
      }
        // videoLink=videosName;
        if (res.data.images && res.data.images.length > 0) {
          if(res?.data?.images[0]?.image){
          setimagecov(res?.data?.images[0]?.image.split("/")[1]);
          }
          if(res?.data?.images[1]?.image){
          setimage1(res?.data?.images[1]?.image.split("/")[1]);
          }
          if(res?.data?.images[2]?.image){
          setimage2(res?.data?.images[2]?.image.split("/")[1]);
          }
          if(res?.data?.images[3]?.image){
          setimage3(res?.data?.images[3]?.image.split("/")[1]);
          }
          seturlListshow(true);
        }
        if (res.data.videos && res.data.videos[0]!=null && res.data.videos.length > 0 && !res.data.videos[0].includes('http')) {
          setvidurlList(res.data.videos);
          if(res.data.videos[0].includes('.'))
          {
          setvidurlListshow(true);
          }
        }
      })
      .catch((err) => console.log(err));
    }
  }, []);
  const getCategoryame = (categortyTree, categoryId) => {
    if (categortyTree._id === categoryId) {
      return categortyTree;
    }
    for (let child of categortyTree.subCategories) {
      const result = getCategoryame(child, categoryId);
      if (result) {
        return result;
      }
    }
    return null;
  };
  // Delete image

  function deleteImg(spcl, ele) {
    // seturlListshow(false)
    seturlList([]);
    imagesName.splice(spcl, 1);
    switch (spcl) {
      case 0:
        setimagecov("");
        break;
      case 1:
        setimage1("");
        break;
      case 2:
        setimage2("");
        break;
      case 3:
        setimage3("");
        break;
    }
    let eleLoader = document.getElementById(ele);
    seturlList(imagesName);
    eleLoader.setAttribute("class", "spinner-border text-info");
  }

  // Delete video

  function deletevideo(index) {
    setvidurlListshow(false);
    setvidurlList([]);

    videosName.splice(index, 1);
    let eleLoader = document.getElementById("loader-Vid-upload");

    setvidurlList(videosName);

    eleLoader.setAttribute("class", "spinner-border text-info");

    setTimeout(() => {
      eleLoader.removeAttribute("class");

      setvidurlListshow(true);
    }, 1000);
  }

  // play video

  function playVideo(vidId) {
    currentLink = vidId;
    setvideoShow("block");
    document.getElementById("cntn").classList.add("div-bk");
  }

  // Hide player
  function hidePlayer() {
    document.getElementById("vidPlayer").pause();
    document.getElementById("cntn").classList.remove("div-bk");
    setvideoShow("none");
  }

  function handlePkgChange(pkgId, key, value) {
    const nextPkgs = [...sellerPkgs];
    const pkg = nextPkgs.find((a) => a.id === pkgId);
    if (
      key == "packageWidth" ||
      key == "packageHeight" ||
      key == "packageLength"
    ) {
      pkg[key] = value * 30.48;
      pkg.vWeight =
        (pkg.packageWidth * pkg.packageLength * pkg.packageHeight) / 5000;
      pkg.vWeight = pkg.vWeight.toFixed(2);
    } else {
      pkg[key] = value;
    }
    setSellerPkgs(nextPkgs);
  }

  // Validation
  const validatePackages = () => {
    for (const pkg of packages) {
      if (!pkg.productName || pkg.productName === "" || pkg.productName === null || pkg.productName === undefined ) {
        alert.info("All fields are required for each package.");
        return false;
      }
      if (pkg.images.some((img) => img === "") || pkg.images.length < 4 || pkg.images.some((img) => img === null)) {
        alert.info("All images must be uploaded for each package.");
        return false;
      }
      if (pkg.packageLength < 1 || pkg.packageWidth < 1 || pkg.packageHeight < 1) {
        alert.info("Values must be greater than 0.");
        return false;
      }
      if (!pkg.weight|| !pkg.actualWeight) {
        alert.info("All fields are required for each package.");
        return false;
      }
      if (pkg.weight < 1 || pkg.actualWeight < 1) {
        alert.info("Values must be greater than 0.");
        return false;
      }
      if(Number(pkg.weight) < Number(pkg.actualWeight)){
        alert.info("After packaging weight cannot be less than package weight.");
        return false;
    }
    }
    return true;
  };

   function AddProduct() {

    setError(true);
    var categories = [];
    let currcato = [];
    currcato = catList;
    for (let i = 0; i < histStat.length; i++) {
      categories.push(currcato[histStat[i]]._id);
      currcato = currcato[histStat[i]].subCategories;
    }
      if (!isselectedCat) {
        window.scrollTo(0, 0);
        // alert.info("Please select a category");
      } else if (pName === undefined || pName === "") {
        window.scrollTo(0, 0);
        // alert.info("Please enter a valid Product name");
      } else if (imagecov === undefined || imagecov === "") {
        window.scrollTo(0, 200);
        // alert.info("Please upload cover image.");
      } else if (vidurlList.length > 1) {
        // alert.info("Max. of 1 video is allowed");
        window.scrollTo(0, 300);
      } else if (description === undefined || description === "") {
        window.scrollTo(0, 350);
        // alert.info("Please fill Product description");
        window.scrollTo(0, 700);
      } else if (longDesLen < 100) {
        window.scrollTo(0, 700);
        // alert.info("Product description cannot be less than 100 characters");
      } else if (keywords.length < 1) {
        if (currKeyword !== undefined && currKeyword !== "") {
          setkeywords((keywords) => keywords.concat(currKeyword));
        } else {
          // alert.info("Please enter at least one keyword to continue");
          window.scrollTo(0, 700);
        }
      } else if (brand === undefined || brand === "") {
        // alert.info("Please select a brand");
        window.scrollTo(0, 700);
      } else if (
        price === undefined ||
        price === "" ||
        price === 0 ||
        price < 1 ||
        price.includes(".")
      ) {
        // alert.info("Please enter a valid Product price");
        window.scrollTo(0, 1000);
      } else if (
        taxClass === undefined ||
        taxClass === "" ||
        taxClass === "GST"
      ) {
        // alert.info("Please select a valid Tax Class");
        window.scrollTo(0, 1000);
      }
      //SL-699
      else if (stockValue === undefined || stockValue === "" || isNaN(stockValue) || stockValue == Number(0)) {
        window.scrollTo(0, 1200);
      }
      else {
        for (let i = 0; i < imagesName.length; i++) {
          if (i === 0) {
            let data = {
              baseImage: true,
              smallImage: false,
              thumbnail: false,
              visible: false,
              image: "products/" + imagesName[i],
              label: imagesName[i],
            };
            imgUrls.push(data);
          } else {
            let data = {
              baseImage: false,
              smallImage: false,
              thumbnail: false,
              visible: false,
              image: "products/" + imagesName[i],
              label: imagesName[i],
            };
            imgUrls.push(data);
          }
        }

        let productData;
        let videoLink;
        if (videosName.length > 0) {
          videoLink = videosName;
        } else {
          videoLink = utubevideo;
        }
        if (props.match.params.id) {
          productData = {
            _id: props.match.params.id,
            images: imgUrls,
            description: description,
            price: price,
            taxClass: taxClass,
            productName: pName,
            videos: videoLink,
            HSN: hsnCode,
            manufacturer: brandid,
            shortDescription: shortdescription,
            categories: category,
          
            originCountry: selectedCountry,
           
            metaInformation: {
              keywords: keywords,
            },
            stock: Number(stockValue)//SL-699
          };
        } else {
          productData = {
            images: imgUrls,
            description: description,
            price: price,
            taxClass: taxClass,
            productName: pName,
            videos: videoLink,
            HSN: hsnCode,
            manufacturer: brandid,
            shortDescription: shortdescription,
            categories: categories,
            originCountry: selectedCountry,
          
            metaInformation: {
              keywords: keywords,
            },
            stock: Number(stockValue)//SL-699
          };
        }
        api.product
          .addNewProduct(productData)
          .then((res) => {
            alert.success("Product added successfully");
            if (status == "pending") {
              window.location.assign(
                "/my-inventory/new_product_request/manual"
              );
            } else {
              // window.location.assign("/my-inventory/new_product_request/drafted");
            }
          })
          .catch((err) => {
            console.log(err);
            alert.error("Failed to add product");
          });
      }
    
  }

  function saveAsDraft() {
    setError(true)
    if (imagecov === undefined || imagecov === "") {
      window.scrollTo(0, 200);
      return false;
    }
     //SL-699
    else if(stockValue === undefined || stockValue === "" || isNaN(stockValue) || stockValue == Number(0)){
      window.scrollTo(0, 1200);
      return false;
    }
    if(pkgCount>0){
      for (let k = 0; k < sellerPkgs.length; k++) {
        if (
          sellerPkgs[k].productName === "" ||
          sellerPkgs[k].productName === undefined ||
          sellerPkgs[k].productName <= 0
        ) {
          // alert.info("Please enter a valid productName");
          return false;
        } else if (
          sellerPkgs[k].actualWeight === "" ||
          sellerPkgs[k].actualWeight === undefined ||
          sellerPkgs[k].actualWeight <= 0
        ) {
          // alert.info("Please enter a valid weight");
          return false;
        } else if (
          sellerPkgs[k].weight === "" ||
          sellerPkgs[k].weight === undefined ||
          sellerPkgs[k].weight <= 0
        ) {
          // alert.info("Please enter a valid after packaging weight");
          return false;
        } else if (
          sellerPkgs[k].packageLength === "" ||
          sellerPkgs[k].packageLength === undefined ||
          sellerPkgs[k].packageLength <= 0
        ) {
          // alert.info("Please enter a valid  length");
          return false;
        } else if (
          sellerPkgs[k].packageWidth === "" ||
          sellerPkgs[k].packageWidth === undefined ||
          sellerPkgs[k].packageWidth <= 0
        ) {
          // alert.info("Please enter a valid  width");
          return false;
        } else if (
          sellerPkgs[k].packageHeight === "" ||
          sellerPkgs[k].packageHeight === undefined ||
          sellerPkgs[k].packageHeight <= 0
        ) {
          // alert.info("Please enter a valid  height");
          return false;
        } else {
          // sellerPkgs[k].status = "APPROVED";
          setError(false)
        }
      }
    }
    var categories = [];
    let currcato = [];
    currcato = catList;
    for (let i = 0; i < histStat.length; i++) {
      categories.push(currcato[histStat[i]]._id);
      currcato = currcato[histStat[i]].subCategories;
    }


        for (let i = 0; i < imagesName.length; i++) {
          if (i === 0) {
            let data = {
              baseImage: true,
              smallImage: false,
              thumbnail: false,
              visible: false,
              image: "products/" + imagesName[i],
              label: imagesName[i],
            };
            imgUrls.push(data);
          } else {
            let data = {
              baseImage: false,
              smallImage: false,
              thumbnail: false,
              visible: false,
              image: "products/" + imagesName[i],
              label: imagesName[i],
            };
            imgUrls.push(data);
          }
        }

        let productData;
        let pkgData;
        let videoLink;
        if (videosName.length > 0) {
          videoLink = videosName;
        } else {
          videoLink = utubevideo;
        }
        if (props.match.params.id) {
          productData = {
            _id: props.match.params.id,
            images: imgUrls,
            description: description,
            price: price,
            taxClass: taxClass,
            productName: pName,
            videos: videoLink,
            HSN: hsnCode,
            manufacturer: brandid,
            shortDescription: shortdescription,
            categories: category,
            originCountry: selectedCountry,
            metaInformation: {
              keywords: keywords,
            },
            pkgs: sellerPkgs,
            stock:Number(stockValue)//SL-699
          };
        }

        // pkgData = {
        //   "product": "",
        //   "status": "PENDING",
        //   "pkg": { "productName": pName,
        //            "pkgs": sellerPkgs
        //           },
        //   "categories": categories
        // }
        

        api.product
          .addNewProduct(productData)
          .then((res) => {
            alert.success("Product added successfully");
            if (status == "pending") {
              window.location.assign(
                "/my-inventory/new_product_request/manual"
              );
            } else {
              window.location.assign("/my-inventory/new_product_request/drafted");
            }
          })
          .catch((err) => {
            console.log(err);
            alert.error("Failed to add product");
          });
      }

  // Show Image
 async function showImage (event, spcl) {

    let comImg;
    let imageFinal;
    let registerImage;
    let isimgsSizevalid = true;
    let limit = event.target.files.length;
    // for (let i = 0; i < limit; i++) {
    //   if (event.target.files[i].size > variables.limit.Newproductupload.image) {
    //     isimgsSizevalid = false;
    //   }
    // }
    // if (isimgsSizevalid) {
    setimgLabelDisable(true);
    seturlListshow(false);
    for (let i = 0; i < limit; i++) {
      let convertedImg = await convertFileToWebP(event.target.files[i]);
      var str = convertedImg.name;
      let extension = convertedImg.name.slice(
        convertedImg.name.lastIndexOf(".")
      );
      comImg = str.replace(/[^\w]/g, "");

      imageFinal = "img_" + vendorId + "_" + comImg + extension;
      registerImage = convertedImg;
      if (spcl === "cov") {
        imagesName.unshift(imageFinal);
      } else {
        imagesName.push(imageFinal);
      }
      switch (spcl) {
        case "cov":
          setimagecov(imageFinal);
          break;
        case "1":
          setimage1(imageFinal);
          break;
        case "2":
          setimage2(imageFinal);
          break;
        case "3":
          setimage3(imageFinal);
          break;
      }
      var data = {
        imageName: imageFinal,
        type: "products",
      };

      api.product
        .saveProductImage(data)
        .then((res) => {
          axios({
            method: "put",
            url: res.data,
            data: registerImage,
            onUploadProgress: (data) => {
              //Set the progress value to show the progress bar
              setimgprogress(Math.round((100 * data.loaded) / data.total));
            },
          })
            .then((response) => {
              setimgprogress();
              setimgLabelDisable(false);
              seturlList(imagesName);
              seturlListshow(true);
            })
            .then((response) => {
              setimgprogress();
              setimgLabelDisable(false);
              seturlList(imagesName);
              seturlListshow(true);
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch((err) => console.log(err));
      s3Urls.push(imageFinal);
    }
    // } else {
    //   alert.info("Please upload image of size less than or equal to 500 kb");
    // }
  }

  // Show Video

  function showVideo(event) {
    setvidurlListshow(false);
    let comImg;
    let imageFinal;
    let registerImage;
    let videoSize = 0;
    if (event.target.files.length > 1 || vidurlList.length === 1) {
      alert.info("A max of 1 video can be uploaded");
      setvidurlListshow(true);
    }
    if (event.target.files.length > 0) {
      for (let i = 0; i < 1; i++) {
        videoSize = videoSize + event.target.files[i].size;
      }
      if (videoSize <= variables.limit.Newproductupload.video) {
        for (let i = 0; i < 1; i++) {
          var str = event.target.files[i].name;
          let extension = event.target.files[i].name.slice(
            event.target.files[i].name.lastIndexOf(".")
          );
          comImg = str.replace(/[^\w]/g, "");
          imageFinal = "vid_" + vendorId + "_" + comImg + extension;
          registerImage = event.target.files[0];
          var data = {
            imageName: imageFinal,
            type: "products",
            bucket: "m",
          };
          imageFinal = "products/vid_" + vendorId + "_" + comImg + extension;
          videosName.push(imageFinal);
          api.product
            .saveProductImage(data)
            .then((res) => {
              axios({
                method: "put",
                url: res.data,
                data: registerImage,
                onUploadProgress: (data) => {
                  setProgress(Math.round((100 * data.loaded) / data.total));
                },
              })
                .then((response) => {
                  setProgress();

                  setvidurlList(videosName);
                  setvidurlListshow(true);
                })
                .then((response) => {
                  setProgress();

                  setvidurlList(videosName);
                  setvidurlListshow(true);
                })
                .catch((error) => {
                  console.log(error);
                });
            })
            .catch((err) => console.log(err));
          vids3Urls.push(imageFinal);
        }
      } else {
        alert.info("A max size of 15 Mb video can be uploaded");
      }
    }
  }

  // Key down function
  function keyDnfun(e, field) {
    if (field === "pName") {
      if (e.keyCode === 8 && pNameLen <= 59) {
        setpNameLen(61 - e.target.value.length);
        backeyactive = true;
      } else {
        backeyactive = false;
      }
    } else if (field === "longdes") {
      if (e.keyCode === 8 && longDesLen > 0) {
        setlongDesLen(e.target.value.length);
        backeyactive = true;
      } else {
        backeyactive = false;
      }
    }
  }

  // Push keyword to array function
  function pushKeyword(e) {
    if ((e.keyCode === 13 || e.keyCode === 186) && currKeyword !== "") {
      setkeywords((keywords) => keywords.concat(currKeyword));
      setcurrKeyword("");
    }
  }

  function pushKeywordclick(e) {
    e.preventDefault();
    if (currKeyword !== "") {
      setkeywords((keywords) => keywords.concat(currKeyword));
      setcurrKeyword("");
    }
  }

  // Delete a keyword
  function delKeyword(index) {
    let k = [];
    k = keywords.filter((item, j) => j !== index);
    setkeywords(k);
  }

  function changeUi(e) {
    histStat.push(e);
    setscList(mcList[e].subCategories);
    setbreadCrumb((breadCrumb) => breadCrumb.concat(mcList[e].categoryName));
    setState("subCategories");
  }

  // Sub Category Handling
  function handleSubCategory(n) {
    let isvalinbreadcrumb = false;
    breadCrumb.map((item, index) => {
      if (item === scList[n].categoryName) {
        isvalinbreadcrumb = true;
      }
    });

    if (scList[n].subCategories.length > 0) {
      let div = document.getElementById("subCat_cntn");
      div.style.display = "none";
      if (isselectedCat) {
        breadCrumb.splice(breadCrumb.length - 1, 1);
        setbreadCrumb(breadCrumb);
        histStat.splice(histStat.length - 1, 1);
        histStat.push(n);
        setscList(scList[n].subCategories);
        setbreadCrumb((breadCrumb) =>
          breadCrumb.concat(scList[n].categoryName)
        );
        setisselectedCat(false);
        div.style.display = "block";
      } else {
        histStat.push(n);
        !isvalinbreadcrumb ? (
          setbreadCrumb((breadCrumb) =>
            breadCrumb.concat(scList[n].categoryName)
          )
        ) : (
          <></>
        );
        setscList(scList[n].subCategories);
        setState("subCategories");
        div.style.display = "block";
      }
    } else {
      setShow(false);
      setselectedcat(scList[n].categoryName);
      if (isselectedCat) {
        breadCrumb.splice(breadCrumb.length - 1, 1);
        histStat.splice(histStat.length - 1, 1);
        histStat.push(n);
        setbreadCrumb((breadCrumb) =>
          breadCrumb.concat(scList[n].categoryName)
        );
      } else {
        setisselectedCat(true);
        histStat.push(n);
        !isvalinbreadcrumb ? (
          setbreadCrumb((breadCrumb) =>
            breadCrumb.concat(scList[n].categoryName)
          )
        ) : (
          <></>
        );
      }
    }
  }

  // Home category
  function gotohomeCat() {
    setbreadCrumb([]);
    histStat = [];
    setState("category");
    setisselectedCat(false);
  }

  // Breadcrumb function
  function breadFunc(index, histSt) {
    if (index === breadCrumb.length - 1 && breadCrumb.length > 0) {
    } else {
      if (index !== breadCrumb[breadCrumb.length - 1]) {
        setisselectedCat(false);
      }
      let i = 0;
      var arro = [];
      arro = mcList;
      while (i <= index) {
        let no = histStat[i];
        arro = arro[no].subCategories;
        i++;
      }
      breadCrumb.splice(index + 1, breadCrumb.length);
      histStat.splice(index + 1, histStat.length);
      setbreadCrumb(breadCrumb);
      setscList(arro);
      setState("subCategories");
    }
  }

  // Fetch brands
  function fetchbrands(name) {
    setbrandInput(name);
    setbrand("");
    setbrandid("");
    api.brand
      .getManufacturers(searchManufacturers(name))
      .then((res) => {
        setbrandList(res.data);
      })
      .catch((err) => console.log(err));
  }

  // Handle brand click
  function handleBrandClick(name, id) {
    setbrandInput(name);
    setbrand(name);
    setbrandList([]);
    setbrandid(id);
  }

  // sl-712
  const handlePackageSubmission = (packages) => {
    packages.forEach((element, index) => {
      element.id = index
    });
    setSellerPkgs(packages)
  }

  /**
   * SL-699
   * Handle Stock Change
   * @param {*} id 
   * @param {*} value 
   */
  const handleStockChange = (stockValue) => {
    //Only allow numeric values
    if (/^\d*$/.test(stockValue))
      setStockValue(stockValue);
  };

  return (
    <>
      <div id="contain-vid-P" style={{ display: videoShow }}>
        <span id="vid-P-cross" onClick={() => hidePlayer()}>
          <i className="bi bi-x-circle-fill"></i>
        </span>
        <video
          id="vidPlayer"
          src={currentLink}
          controls
          width="100"
          height="65"
        />
      </div>
      <div className="add_pro_form_cntn" id="cntn">
        {/* 1 */}
        <div className="add_pro_form_card">
          <div className="add_pro_form_head add_pro_form_head_fo">
            <p className="add_pro_form_head_bi">Basic Information</p>
            <p className="add_pro_form_head_ap">Add a new Product</p>
          </div>
          <div className="row add_pro_form_rows">
            <div className="col-2 add_pro_form_titles">*Select Category</div>
            <div className="col-10">
              {!props.match.params.id ?
                <select
                  className="add_pro_form_card_input add_pro_form_inp_select"
                  value={selectedcat}
                  onClick={() => handleShow()}
                >
                  {selectedcat ? <option selected>{selectedcat}</option> : <></>}
                </select> :
                <input
                  type="text"
                  className="add_pro_form_card_input"
                  value={selectedcat}
                  disabled
                />
              }
              <Offcanvas
                show={show}
                onHide={handleClose}
                className="h-75"
                placement="bottom"
              >
                <Offcanvas.Header closeButton>
                  <Offcanvas.Title>Select a category</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                  {state === "category" && (
                    <div className="p-0  pr">
                      <Container className="d-flex jc-center ">
                        {mcList.map((item, index) => {
                          return (
                            <ul
                              className="l-n"
                              style={{ width: "30%" }}
                              key={index}
                            >
                              <li>
                                <a
                                  onClick={() => changeUi(index)}
                                  className=" text-dark updatePro-Btn-Modal"
                                  key={props.id}
                                >
                                  <Row className="">
                                    <Card className="card-size text-center">
                                      <Card.Body className="card-padding1">
                                        <img
                                          src={
                                            "https://s3.toolsvilla.com/" +
                                            item.image
                                          }
                                          className="w-50 p-1"
                                        ></img>
                                        <p className="fs-15 theme-col pt-2 f-600">
                                          {item.categoryName}{" "}
                                          <i className="bi bi-arrow-right-circle-fill mx-2 link-primary"></i>
                                        </p>
                                      </Card.Body>
                                      <Card.Footer className="bg-none b-n"></Card.Footer>
                                    </Card>
                                  </Row>
                                </a>
                              </li>
                            </ul>
                          );
                        })}
                      </Container>
                    </div>
                  )}

                  {state === "subCategories" && (
                    <>
                      <div
                        id="subCat_cntn"
                        className="scroll list-i"
                        style={{ backgroundImage: `url("/menu-bg.jpg")` }}
                      >
                        <ul className="d-flex mobi_cate_breadcrumb l-n text-white py-2 f-500 top-ul">
                          <a
                            className="t-d3 fnt_on  mx-1"
                            onClick={() => gotohomeCat()}
                          >
                            {" "}
                            <li>
                              <i
                                className="fa fa-home"
                                color="yellow"
                                aria-hidden="true"
                              ></i>
                              <span className="t-d2 f-700">/</span>
                            </li>
                          </a>
                          {breadCrumb.length > 0 ? (
                            breadCrumb.map((item, index) => {
                              return (
                                <a
                                  className="t-d3 fnt_on mx-1"
                                  onClick={() =>
                                    breadFunc(index, histStat[index])
                                  }
                                  key={index}
                                >
                                  <li>
                                    {item}
                                    <span className="t-d2 f-700">/</span>
                                  </li>
                                </a>
                              );
                            })
                          ) : (
                            <></>
                          )}
                        </ul>
                      </div>
                      <Container className="d-flex jc-center subCate-cntn">
                        {scList.map((item, index) => {
                          if (item.subCategories.length > 0) {
                            return (
                              <Categories
                                key={index}
                                id={index}
                                subName={item.categoryName}
                                image={item.image}
                                func={handleSubCategory}
                                from="form"
                                spcl="issub"
                              />
                            );
                          } else {
                            if (
                              selectedcat &&
                              selectedcat === item.categoryName
                            ) {
                              return (
                                <Categories
                                  key={index}
                                  id={index}
                                  subName={item.categoryName}
                                  image={item.image}
                                  func={handleSubCategory}
                                  from="form"
                                  spcl="finalcat"
                                  applied={true}
                                />
                              );
                            } else {
                              return (
                                <Categories
                                  key={index}
                                  id={index}
                                  subName={item.categoryName}
                                  image={item.image}
                                  func={handleSubCategory}
                                  from="form"
                                  spcl="finalcat"
                                />
                              );
                            }
                          }
                        })}
                      </Container>
                    </>
                  )}
                </Offcanvas.Body>
              </Offcanvas>
            </div>
          </div>
          {!isselectedCat && error ? (
            <div className="row add_pro_form_rows">
              <div className="col-2 add_pro_form_titles">&nbsp;</div>
              <div className="col-10">
                <p className="error">Please select a category</p>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>

        {/* 2 */}
        <div className="add_pro_form_card">
          <div className="row add_pro_form_rows">
            <div className="col-2 add_pro_form_titles">*Product Name</div>
            <div className="col-10">
              <input
                type="text"
                className="add_pro_form_card_input"
                placeholder="Upto 60 characters"
                value={pName}
                onKeyDown={(e) => keyDnfun(e, "pName")}
                maxLength="60"
                onChange={(e) => {
                  setpName(e.target.value);
                  if (!backeyactive) {
                    setpNameLen(60 - e.target.value.length);
                  }
                }}
              />
            </div>
          </div>
          <div className="row add_pro_form_rows">
            <div className="col-2 add_pro_form_titles"></div>
            <div className="col-10">
              <p className="text-success fs-12 mt-1">
                ({pNameLen} characters remaining)
              </p>
              {!pName && error && (
                <p className="error">Please enter a valid Product name</p>
              )}
            </div>
          </div>

          {/* Images */}
          <div className="row add_pro_form_rows">
            <div className="col-2 add_pro_form_titles mtm-13">
              *Product Images
              {/* <p className="fs-12 mt-1">(Size max. 500 kb)</p> */}
            </div>
            <div className="col-10 d-flex product-image-grid">
              {imgprogress && (
                <ProgressBar
                  id="progress-B"
                  className="add_pro_form_progressbar"
                  now={imgprogress}
                  label={`${imgprogress}%`}
                />
              )}
              <div className="add_pro_form_image_box">
                <div className="add_pro_form_image_cntn vid-P">
                  <label
                    for={"imgUploadCov"}
                    id="uploadIcon"
                    className="add_pro_form_label"
                  >
                    {/* <i
                      className="fa fa-plus-circle add_pro_form_i_nm"
                      aria-hidden="true"
                    ></i> */}
                    <img src="/ImageAdd.png" alt="Add image" />
                  </label>
                  {urlListshow === true &&
                    imagecov !== undefined &&
                    imagecov !== "" ? (
                    <>
                      <img
                        src={
                          "https://s3.toolsvilla.com/products/" +
                          imagecov
                        }
                        className="add_pro_form_image_file vid-P"
                        alt="img"
                        id="contain-Img-Pro-Cov"
                      />
                      {/* <i className="bi bi-x-square-fill fs-14 text-yellow add_pro_form_med_del_btn_img" onClick={() => deletevideo(index)}></i> */}
                      <i
                        className="bi bi-trash fs-14 add_pro_form_med_del_btn_img"
                        onClick={() => deleteImg(0, "contain-Img-Pro-Cov")}
                      ></i>
                    </>
                  ) : (
                    <></>
                  )}
                </div>
                <label>*Cover photo</label>
                <input
                  type="file"
                  id="imgUploadCov"
                  className="add_pro_form_uploadFile"
                  onChange={(event) => showImage(event, "cov")}
                  onClick={(e) => (e.target.value = null)}
                  accept="image/*"
                />
              </div>

              {/* 1 image */}
              <div className="add_pro_form_image_box">
                <div className="add_pro_form_image_cntn">
                  <label
                    for={"imgUploadImg_1"}
                    id="uploadIcon"
                    className="add_pro_form_label"
                  >
                    {/* <i
                      className="fa fa-plus-circle add_pro_form_i_nm"
                      aria-hidden="true"
                    ></i> */}
                    <img src="/ImageAdd.png" alt="Add image" />
                  </label>
                  {urlListshow === true &&
                    image1 !== undefined &&
                    image1 !== "" ? (
                    <>
                      <img
                        src={
                          "https://s3.toolsvilla.com/products/" +
                          image1
                        }
                        className="add_pro_form_image_file vid-P"
                        alt="img"
                        id="contain-Img-Pro-1"
                      />
                      {/* <i className="bi bi-x-square-fill fs-14 text-yellow add_pro_form_med_del_btn_img" onClick={() => deletevideo(index)}></i> */}
                      <i
                        className="bi bi-trash fs-14 add_pro_form_med_del_btn_img"
                        onClick={() => deleteImg(1, "contain-Img-Pro-1")}
                      ></i>
                    </>
                  ) : (
                    <></>
                  )}
                </div>
                <label>Image 1</label>
                <input
                  type="file"
                  id="imgUploadImg_1"
                  className="add_pro_form_uploadFile"
                  onChange={(event) => showImage(event, "1")}
                  onClick={(e) => (e.target.value = null)}
                  accept="image/*"
                />
              </div>

              {/* 2 image */}
              <div className="add_pro_form_image_box">
                <div className="add_pro_form_image_cntn">
                  <label
                    for={"imgUploadImg_2"}
                    id="uploadIcon"
                    className="add_pro_form_label"
                  >
                    {/* <i
                      className="fa fa-plus-circle add_pro_form_i_nm"
                      aria-hidden="true"
                    ></i> */}
                    <img src="/ImageAdd.png" alt="Add image" />
                  </label>
                  {urlListshow === true &&
                    image2 !== undefined &&
                    image2 !== "" ? (
                    <>
                      <img
                        src={
                          "https://s3.toolsvilla.com/products/" +
                          image2
                        }
                        className="add_pro_form_image_file vid-P"
                        alt="img"
                        id="contain-Img-Pro-2"
                      />
                      {/* <i className="bi bi-x-square-fill fs-14 text-yellow add_pro_form_med_del_btn_img" onClick={() => deletevideo(index)}></i> */}
                      <i
                        className="bi bi-trash fs-14 add_pro_form_med_del_btn_img"
                        onClick={() => deleteImg(2, "contain-Img-Pro-2")}
                      ></i>
                    </>
                  ) : (
                    <></>
                  )}
                </div>
                <label>Image 2</label>
                <input
                  type="file"
                  id="imgUploadImg_2"
                  className="add_pro_form_uploadFile"
                  onChange={(event) => showImage(event, "2")}
                  onClick={(e) => (e.target.value = null)}
                  accept="image/*"
                />
              </div>

              {/* 3 image */}
              <div className="add_pro_form_image_box">
                <div className="add_pro_form_image_cntn">
                  <label
                    for={"imgUploadImg_3"}
                    id="uploadIcon"
                    className="add_pro_form_label"
                  >
                    {/* <i
                      className="fa fa-plus-circle add_pro_form_i_nm"
                      aria-hidden="true"
                    ></i> */}
                    <img src="/ImageAdd.png" alt="Add image" />
                  </label>
                  {urlListshow === true &&
                    image3 !== undefined &&
                    image3 !== "" ? (
                    <>
                      <img
                        src={
                          "https://s3.toolsvilla.com/products/" +
                          image3
                        }
                        className="add_pro_form_image_file vid-P"
                        alt="img"
                        id="contain-Img-Pro-3"
                      />
                      {/* <i className="bi bi-x-square-fill fs-14 text-yellow add_pro_form_med_del_btn_img" onClick={() => deletevideo(index)}></i> */}
                      <i
                        className="bi bi-trash fs-14 add_pro_form_med_del_btn_img"
                        onClick={() => deleteImg(3, "contain-Img-Pro-3")}
                      ></i>
                    </>
                  ) : (
                    <></>
                  )}
                </div>
                <label>Image 3</label>
                <input
                  type="file"
                  id="imgUploadImg_3"
                  className="add_pro_form_uploadFile"
                  onChange={(event) => showImage(event, "3")}
                  onClick={(e) => (e.target.value = null)}
                  accept="image/*"
                />
              </div>
            </div>
          </div>
          {!imagecov && error && (
            <div className="row add_pro_form_rows">
              <div className="col-2 add_pro_form_titles"></div>
              <div className="col-10 add_pro_form_titles">
                <p className="error">Please upload cover image.</p>
              </div>
            </div>
          )}

          {/* Videos */}
          <div className="row add_pro_form_rows">
            {/* Video */}
            <div className="col-2 add_pro_form_titles">Product Video</div>
            <div className="col-10 d-flex justify-content-between align-items-center product-video-grid">
              <div className="w-50 d-flex">
                <div className="add_pro_form_image_box">
                  {progress && (
                    <ProgressBar
                      id="progress-B"
                      className="add_pro_form_progressbar"
                      now={progress}
                      label={`${progress}%`}
                    />
                  )}
                  <div className="add_pro_form_image_cntn">
                    <label
                      for="uploadFile2"
                      id="uploadIcon"
                      className="add_pro_form_label"
                    >
                      {/* <i
                        className="fa fa-plus-circle add_pro_form_i_nm"
                        aria-hidden="true"
                      ></i> */}
                      <img src="./video_icon.png" alt="Add image" />
                    </label>
                    {vidurlListshow === true ? (
                      vidurlList.map((item, index) => {
                        return (
                          <>
                            <video
                              src={
                                "https://media.toolsvilla.com/" +
                                item
                              }
                              className="add_pro_form_video_file vid-P"
                              onClick={() =>
                                playVideo(
                                  "https://media.toolsvilla.com/" +
                                  item
                                )
                              }
                              key={index}
                              alt="img"
                              id="loader-Vid-upload"
                            />
                            <i
                              className="bi bi-x-square-fill fs-14 text-yellow add_pro_form_med_del_btn"
                              onClick={() => deletevideo(index)}
                            ></i>
                            <i
                              className="fa fa-play ms-2 play-tag-vid add_pro_form_med_play_btn"
                              aria-hidden="true"
                              onClick={() =>
                                playVideo(
                                  "https://media.toolsvilla.com/" +
                                  item
                                )
                              }
                            ></i>
                          </>
                        );
                      })
                    ) : (
                      <></>
                    )}
                  </div>

                  <label className="add_pro_form_labels_inf">Cover video</label>
                  <input
                    type="file"
                    id="uploadFile2"
                    className="add_pro_form_uploadFile"
                    onChange={(event) => showVideo(event)}
                    accept="video/*"
                    disabled={
                      utubevideo === undefined || utubevideo === ""
                        ? false
                        : true
                    }
                  />
                </div>
                <div className="add_pro_form_video my-auto">
                  <div className="video-instruction">
                    <span>1. Size Max 15 Mb , Resolution 1280x720p</span>
                    <br></br>
                    <span>2. Duration-10 sec to 60 sec</span>
                    <br></br>
                    <span>3. Format - MP4</span>
                  </div>
                </div>
              </div>
              <div className=" add_pro_form_titles">OR</div>
              <div className="w-50 row">
                <div className="col-3 add_pro_form_titles text-end">URL</div>
                <div className="col-9 my-auto">
                  <input
                    type="text"
                    placeholder="Please enter video url"
                    className="add_pro_form_card_input"
                    value={utubevideo}
                    onChange={(e) => setutubevideo(e.target.value)}
                    disabled={
                      vidurlList.length > 0 || progress > 0 ? true : false
                    }
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row add_pro_form_rows">
            <div className="col-2 add_pro_form_titles"></div>
            {/* <div className="col-10 add_pro_form_titles">
              {vidurlList.length < 1 && !utubevideo && error && (
                <p className="error">Min. of 1 video is required</p>
              )}
              {vidurlList.length > 1 && error && (
                <p className="error">Max. of 1 video is allowed</p>
              )}
            </div> */}
          </div>
          {/* Short description */}
          <div className="row add_pro_form_rows">
            <div className="col-2 add_pro_form_titles">Short Description</div>
            <div className="col-10">
              <textarea
                rows="2"
                className="add_pro_form_card_input"
                onChange={(e) => setshortdescription(e.target.value)}
              />
            </div>
          </div>

          {/* Long description */}
          <div className="row add_pro_form_rows">
            <div className="col-2 add_pro_form_titles mtm-13">
              *Long Description
            </div>
            <div className="col-10">
              <textarea
                rows="4"
                className="add_pro_form_card_input"
                placeholder="Minimum 100 characters"
                value={description}
                onKeyUp={(e) => keyDnfun(e, "longdes")}
                onChange={(e) => {
                  setdescription(e.target.value);
                  if (!backeyactive) {
                    setlongDesLen(e.target.value.length);
                  }
                }}
              />
              <p className="text-success fs-12">({longDesLen} character(s))</p>
            </div>
          </div>
          <div className="row add_pro_form_rows">
            <div className="col-2 add_pro_form_titles mtm-13"></div>
            <div className="col-10">
              {!description && error && (
                <p className="error">Please fill Product description.</p>
              )}
              {longDesLen < 100 && error && (
                <p className="error">
                  Product description cannot be less than 100 characters.
                </p>
              )}
            </div>
          </div>

          {/* Keywords */}
          <div className="row add_pro_form_rows">
            <div className="col-2 add_pro_form_titles">*Keywords</div>
            <div className="col-10">
              <input
                type="text"
                className="add_pro_form_card_input"
                placeholder="Please enter keywords and separate them by pressing enter"
                value={currKeyword}
                onKeyDown={(e) => pushKeyword(e)}
                onChange={(e) => {
                  if (e.target.value !== ";") {
                    setcurrKeyword(e.target.value);
                  }
                }}
              />
            </div>
            {keywords.length > 0 && (
              <>
                <div className="col-2"></div>
                <div className="col-10">
                  <div className="keyword_main_cntn">
                    {keywords.map((item, index) => {
                      return (
                        <span className="keyword_cntn" key={item}>
                          {item}{" "}
                          {/* <i
className="bi bi-trash"
onClick={() => delKeyword(index)}
></i> */}
                          <button
                            class="tag-close"
                            onClick={() => delKeyword(index)}
                          >
                            &times;
                          </button>
                        </span>
                      );
                    })}
                  </div>
                </div>
              </>
            )}
          </div>
          <div className="row add_pro_form_rows">
            <div className="col-2 add_pro_form_titles"></div>
            <div className="col-10">
              {keywords.length == 0 && error && (
                <p className="error">
                  Please enter at least one keyword to continue.
                </p>
              )}
            </div>
          </div>

          {/* Brands */}
          <div className="row">
            <div className="col-md-6 col-sm-6 col-xs-12">
              <div className="row add_pro_form_rows">
                <div className="col-4 add_pro_form_titles">*Brands</div>
                <div className="col-8">
                  <input
                    type="text"
                    className="add_pro_form_card_input"
                    value={brandInput}
                    onChange={(e) => fetchbrands(e.target.value)}
                  />
                  {brandList.length > 0 ? (
                    <>
                      <ul className="brand_List_cntn">
                        {brandList.map((item, index) => {
                          return (
                            <li
                              key={index}
                              className="brand_List text-black"
                              onClick={() => {
                                handleBrandClick(item.name, item.manufacturerId);
                              }}
                            >
                              {item.name}
                            </li>
                          );
                        })}
                      </ul>
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            </div>
            <div className="col-md-6 col-sm-6 col-xs-12">
              <div className="row add_pro_form_rows">
                <div className="col-4 add_pro_form_titles">*Country of Origin</div>
                <div className="col-8">
                  <>
                    <select id="country" className="add_pro_form_card_input" value={selectedCountry} onChange={(e) => setSelectedCountry(e.target.value)}>
                      <option value="">--Please select a country--</option>
                      {Object.entries(countries).map(([code, name]) => (
                        <option key={code} value={code}>
                          {name}
                        </option>
                      ))}
                    </select>
                  </>

                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 col-sm-6 col-xs-12">
              <div className="row add_pro_form_rows">
                <div className="col-4 add_pro_form_titles"></div>
                <div className="col-8">
                  {!brand && error && (
                    <p className="error">Please select a brand.</p>
                  )}
                </div>
              </div>
            </div>
            <div className="col-md-6 col-sm-6 col-xs-12">
              <div className="row add_pro_form_rows">
                <div className="col-4 add_pro_form_titles"></div>
                <div className="col-8">
                  {!selectedCountry && error && (
                    <p className="error">Please select a country.</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 3 */}
        <div className="add_pro_form_card">
          <div className="add_pro_form_head">
            <p className="add_pro_form_head_p">Tax Information</p>
          </div>
          <div className="row">
            {/* Transfer price */}
            <div className="add_pro_form_rows col-md-6 col-sm-6 col-xs-12">
              <div className="row">
                <div className="col-md-4 col-sm-6 col-xs-12 add_pro_form_titles">
                  * Transfer Price
                </div>
                <div className="col-8 col-sm-6 col-xs-12">
                  <input
                    type="number"
                    className="add_pro_form_card_input add_pro_form_card_input_tr_p w-100"
                    onChange={(e) => setPrice(e.target.value)}
                    value={price}
                    onWheel={(e) => e.target.blur()}
                    placeholder="Transfer Price to Toolsvilla (incl. GST)"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-4 col-sm-6 col-xs-12 add_pro_form_titles"></div>
                <div className="col-md-8  col-sm-6 col-xs-12">
                  {(!price || price == 0 || price.includes(".")) && error && (
                    <p className="error">
                      Please enter a valid Transfer price.
                    </p>
                  )}
                </div>
              </div>
            </div>
            {/* Gst */}
            <div className="add_pro_form_rows col-md-6 col-sm-6 col-xs-12">
              <div className="row">
                <div className="col-md-2 col-sm-4 col-xs-12">* GST</div>
                <div className="col-10  col-sm-8 col-xs-12">
                  <select
                    value={taxClass}
                    className="add_pro_form_card_input add_pro_form_inp_select w-100"
                    onChange={(e) => settaxClass(e.target.value)}
                  >
                    <option
                      selected
                      value="GST"
                      disabled
                      hidden
                      style={{ color: "red" }}
                    >
                      Click here to choose
                    </option>
                    {variables?.gstValues?.map((item, index) => {
                      return (
                        <option key={index} value={item}>
                          {item} %
                        </option>
                      );
                    })}
                  </select>

                </div>
              </div>
              <div className="row">
                <div className="col-2 col-sm-4 col-xs-12 add_pro_form_titles"></div>
                <div className="col-10  col-sm-8 col-xs-12">
                  {!taxClass && error && (
                    <p className="error">Please select a valid Tax Class.</p>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* HSN code */}
          <div className="row add_pro_form_rows">
            <div className="col-2 add_pro_form_titles">HSN Code</div>
            <div className="col-10">
              <input
                type="number"
                className="add_pro_form_card_input w-100"
                value={hsnCode}
                onChange={(e) => sethsnCode(e.target.value)}
                onWheel={(e) => e.target.blur()}
                placeholder="Provide the Applicable 4/6/8 Digit HSN Tax Code Of Your Product"
              />
            </div>
          </div>

        </div>
        {/* 4 */}
        {/* SL-699 : Seller Stock Feature Start */}
        <div className="add_pro_form_card">
          <div className="add_pro_form_head">
            <p className="add_pro_form_head_p">Stock Count</p>
          </div>
        
          {/* Stock Quantity code */}
          <div className="row add_pro_form_rows">
            <div className="col-2 add_pro_form_titles">*Enter Stock Count</div>
            <div className="col-10">
              <input
                type="number"
                className="add_pro_form_card_input w-50"
                value={stockValue}
                onChange={(e) => handleStockChange(e.target.value)}
                onWheel={(e) => e.target.blur()}
                placeholder="Please enter the available stock count"
              />
            </div>
          </div>
          
          <div className="row">
                <div className="col-2 add_pro_form_titles"></div>
                <div className="col-10">
                  {(!stockValue || Number(stockValue) <= 0 || stockValue == '0') && error && (
                    <p className="error">
                      Please enter a valid stock inventory count.
                    </p>
                  )}
                </div>
          </div>
        </div>
        {/* SL-699 : Seller Stock Feature End */}
        {/* 5 */}
        <div className="add_pro_form_card">
          <div className="add_pro_form_head">
            <p className="add_pro_form_head_p">Stock Count</p>
          </div>

          {/* Stock Quantity code */}
          <div className="row add_pro_form_rows">
            <div className="col-2 add_pro_form_titles">*Enter Stock Count</div>
            <div className="col-10">
              <input
                type="number"
                className="add_pro_form_card_input w-50"
                value={stockValue}
                onChange={(e) => handleStockChange(e.target.value)}
                onWheel={(e) => e.target.blur()}
                placeholder="Please enter the available stock count"
              />
            </div>
          </div>

          <div className="row">
            <div className="col-2 add_pro_form_titles"></div>
            <div className="col-10">
              {(!stockValue || Number(stockValue) <= 0 || stockValue == '0') && error && (
                <p className="error">
                  Please enter a valid stock inventory count.
                </p>
              )}
            </div>
          </div>
        </div>
        {/* SL-699 : Seller Stock Feature End */}
        {/* 5 */}
        <div className="add_pro_form_card">
      
          {/* Buttons */}
          <div className="add_pro_form_fin_btns ">
            {id ?
              <button onClick={() => saveAsDraft()}>Save as Draft</button> :
              <button onClick={() => AddProduct()}>Save & Publish</button>}
          </div>
        </div>
      </div>
    </>
  );
};

export default Formdemo;